//webpack://ReactSimpleChatbot/lib/steps_components/options/Options.jsx
import styled from 'styled-components';
const Options = styled.ul`
  margin: 2px 0 12px 0;
  padding: 0 6px;
`;
export default Options;
